import { WcsResource, WcsScript, WcsStyle, WcsAttribute } from '@/scripts/libs/wcs/types/wcs-config'

class Resources {
  loadResource = (wcsResource: WcsResource, attributes?: WcsAttribute) => {
    return new Promise((resolve, reject) => {
      let element: HTMLScriptElement | HTMLLinkElement | undefined = undefined
      if (this.resourceIsScript(wcsResource)) {
        element = document.createElement('script')
        element.src = wcsResource.src
        element.async = false
        if (attributes) {
          Object.entries(attributes).forEach(([key, value]) => {
            if (element) {
              element.setAttribute(key, value)
            }
          })
        }
        if (wcsResource.type) {
          element.type = wcsResource.type
        }
      } else if (this.resourceIsStyle(wcsResource)) {
        element = document.createElement('link')
        element.href = wcsResource.href
        element.rel = 'stylesheet'
        element.type = 'text/css'
      }
      if (element) {
        element.onload = () => {
          resolve(wcsResource)
        }
        element.onerror = () => {
          reject(wcsResource)
        }
        document.body.appendChild(element)
      }
    })
  }

  loadResourcesWithCallback = ({
    resources,
    callback,
    attributes,
  }: {
    resources: Array<WcsScript | WcsStyle>
    callback?: () => void
    attributes?: WcsAttribute
  }) => {
    const promises: Promise<any>[] = []
    resources.forEach((url) => {
      promises.push(this.loadResource(url, attributes))
    })
    Promise.all(promises)
      .then(() => {
        if (callback) {
          callback()
        }
      })
      .catch((resource) => {
        console.error(resource + ' failed to load')
      })
  }

  private resourceIsScript = (wcsResource: WcsResource): wcsResource is WcsScript => {
    return 'src' in wcsResource
  }
  private resourceIsStyle = (wcsResource: WcsResource): wcsResource is WcsStyle => {
    return 'href' in wcsResource
  }
}

export default new Resources()
